export const TENANTEXISTS = 'Domain is already exist,try with different domain';
